// 🎯 Regex Patterns para Validação de Conteúdo
export const xmlRegex = /<([^>]+)>/g;
export const boldRegex = /\*(.*?)\*/g;
export const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

/**
 * 🎨 Formata conteúdo XML aplicando formatação em negrito
 * @param {string} xmlString - String XML a ser formatada
 * @returns {string} String formatada
 */
export const formatXml = (xmlString) => {
  // Verifica se o XML contém a assinatura com nome do atendente
  if (boldRegex.test(xmlString)) {
    // Formata o texto dentro da assinatura em negrito
    xmlString = xmlString.replace(boldRegex, "**$1**");
  }
  return xmlString;
};

/**
 * 🎬 Verifica se uma URL é um link do YouTube
 * @param {string} url - URL a ser verificada
 * @returns {boolean} True se for link do YouTube
 */
export const isYouTubeLink = (url) => {
  return youtubeRegex.test(url);
};

/**
 * 📝 Verifica se o conteúdo da mensagem contém XML
 * @param {string} content - Conteúdo da mensagem
 * @returns {boolean} True se contém XML
 */
export const isXmlContent = (content) => {
  return xmlRegex.test(content);
};

/**
 * ✂️ Trunca texto para mensagens citadas
 * @param {string} text - Texto a ser truncado
 * @param {number} maxLength - Comprimento máximo (padrão: 100)
 * @returns {object} { displayText: string, isTruncated: boolean }
 */
export const truncateQuotedText = (text = "", maxLength = 100) => {
  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? text.substring(0, maxLength) + "..." : text;
  
  return {
    displayText,
    isTruncated
  };
};

/**
 * 🔍 Extrai informações de localização do corpo da mensagem
 * @param {string} messageBody - Corpo da mensagem de localização  
 * @returns {object} { imageLocation, linkLocation, descriptionLocation }
 */
export const parseLocationMessage = (messageBody) => {
  const locationParts = messageBody.split("|");
  
  return {
    imageLocation: locationParts[0] || null,
    linkLocation: locationParts[1] || null,
    descriptionLocation: locationParts[2] || null,
  };
};

/**
 * 📞 Extrai informações de contato do corpo da mensagem vCard
 * @param {string} messageBody - Corpo da mensagem de contato
 * @returns {object} { contact: string, numbers: string[] }
 */
export const parseContactMessage = (messageBody) => {
  const array = messageBody.split("\n");
  const numbers = [];
  let contact = "";
  
  for (let index = 0; index < array.length; index++) {
    const line = array[index];
    const values = line.split(":");
    
    for (let ind = 0; ind < values.length; ind++) {
      if (values[ind].indexOf("+") !== -1) {
        numbers.push(values[ind]);
      }
      if (values[ind].indexOf("FN") !== -1) {
        contact = values[ind + 1];
      }
    }
  }
  
  return {
    contact,
    numbers: numbers[0] || null
  };
};

/**
 * 🏷️ Extrai o nome base do arquivo da URL de mídia
 * @param {string} mediaUrl - URL da mídia
 * @returns {string} Nome base do arquivo
 */
export const getMediaFileName = (mediaUrl) => {
  if (!mediaUrl) return "";
  
  const path = require("path");
  return path.basename(mediaUrl);
};

/**
 * 🎭 Determina se uma mensagem deve mostrar o nome do contato
 * @param {object} message - Objeto da mensagem
 * @param {boolean} isGroup - Se é conversa em grupo
 * @returns {boolean} True se deve mostrar o nome
 */
export const shouldShowContactName = (message, isGroup) => {
  return isGroup && !message.fromMe && message.contact?.name;
};

/**
 * 🔄 Determina o tipo de renderização da mensagem baseado no conteúdo
 * @param {object} message - Objeto da mensagem
 * @returns {string} Tipo de renderização
 */
export const getMessageRenderType = (message) => {
  if (message.mediaType === "call_log") return "call_log";
  if (message.fromMe) return message.isPrivate ? "private" : "sent";
  return "received";
};

/**
 * 🎨 Gera classes CSS dinâmicas baseadas no estado da mensagem
 * @param {object} message - Objeto da mensagem
 * @param {object} classes - Objeto de classes CSS
 * @returns {string} Classes concatenadas
 */
export const getMessageClasses = (message, classes) => {
  const baseClass = getMessageRenderType(message);
  const classList = [classes[`message${baseClass.charAt(0).toUpperCase() + baseClass.slice(1)}`]];
  
  if (message.isDeleted) {
    classList.push(classes.deletedMessage);
  }
  
  return classList.join(' ');
};
